import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowExpandHor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowExpandHor"><Path fillRule="evenodd" clipRule="evenodd" d="M7.06077 7.75012L3.56079 11.2501H20.4394L16.9395 7.75012L18.0001 6.68945L23.3108 12.0001L18.0001 17.3108L16.9395 16.2501L20.4395 12.7501H3.56076L7.06077 16.2501L6.00011 17.3108L0.689453 12.0001L6.00012 6.68945L7.06077 7.75012Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowExpandHor;
